import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../environments/environment';

const BASE_URL = `${environment.localSbxUrl}${environment.fullRecoveryAPI}`;
@Injectable()
export class FullRecoveryService {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'Application/json',
    }),
  };

  constructor(private http: HttpClient) {}

  recoverAccount({ email, firstName, lastName, dateOfBirth }) {
    const body = {
      email,
      firstName,
      lastName,
      dateOfBirth,
    };

    return this.http.post(
      BASE_URL + environment.recoverAccountEndpoint,
      body,
      this.httpOptions,
    );
  }

  verifyToken(recoveryToken: string) {
    const body = {
      recoveryToken,
    };

    return this.http.post(
      BASE_URL + environment.verifyTokenEndpoint,
      body,
      this.httpOptions,
    );
  }

  restoreAccount(
    username: string,
    recoveryQuestion: string,
    recoveryAnswer: string,
    stateToken: string,
  ) {
    const body = {
      username,
      recoveryQuestion,
      recoveryAnswer,
      stateToken,
    };

    return this.http.post(
      BASE_URL + environment.restoreAccountEndpoint,
      body,
      this.httpOptions,
    );
  }
}
